import { gql } from '@apollo/client';

export const CREATE_SCHEDULED_TESTER_PUBLIC = gql`
  mutation CreateScheduledTester(
    $projectId: ID!,
    $segmentId: ID!,
    $email: String!,
    $firstName: String!,
    $lastName: String!,
    $startAt: ISO8601DateTime!,
    $forceReschedule: Boolean!,
    $timeZone: String!,
    $guest: Boolean,
  ) {
    createScheduledTester(
      projectId: $projectId,
      segmentId: $segmentId,
      email: $email,
      firstName: $firstName,
      lastName: $lastName,
      startAt: $startAt,
      forceReschedule: $forceReschedule,
      timeZone: $timeZone
      guest: $guest,
    ) {
      testSessionId
    }
  }
`;
export const GET_PROJECT_BY_ID = gql`
  query Project($projectId: ID!) {
    project(id: $projectId) {
      id
      participantsSource
      company {
        id
        collectByoTestersInfo
      }
    }
  }
`;
